export const RELATIONSHIP_CONTACT_TYPE_OPTIONS = [
	{ value: 'premiumFunder', label: 'Premium funder' },
	{ value: 'underwriter', label: 'Underwriter' },
	{ value: 'insurer', label: 'Insurer' },
	{ value: 'referrer', label: 'Referrer' },
	{ value: 'other', label: 'Other' },
];

export const RELATIONSHIP_CONTACT_STATUS_OPTIONS = [
	{ value: 'active', label: 'Active' },
	{ value: 'prospectingDeveloping', label: 'Prospecting / Developing' },
	{ value: 'strategic', label: 'Strategic' },
	{ value: 'archived', label: 'Archived' },
];

export const RELATIONSHIP_CONTACT_TYPE_LABELS = Object.fromEntries(
	RELATIONSHIP_CONTACT_TYPE_OPTIONS.map(({ value, label }) => [value, label]),
);

export const RELATIONSHIP_CONTACT_STATUS_LABELS = Object.fromEntries(
	RELATIONSHIP_CONTACT_STATUS_OPTIONS.map(({ value, label }) => [value, label]),
);

export const DEFAULT_RELATIONSHIP_CONTACT_STATUSES = RELATIONSHIP_CONTACT_STATUS_OPTIONS.filter(
	(option) => option.value !== 'archived',
).map((option) => option.value);

export const toRelationshipContactStatuses = (relationshipStatus) =>
	(relationshipStatus ?? DEFAULT_RELATIONSHIP_CONTACT_STATUSES).filter((value) =>
		Object.hasOwn(RELATIONSHIP_CONTACT_STATUS_LABELS, value),
	);
